/** One cel of the player's 64x64 body sheet. */
export interface KnightFrame {
  /** Horizontal draw offset, in pixels. */
  readonly xx: number;
  /** Vertical draw offset, in pixels. */
  readonly yy: number;
  /** Frames this cel is held for. */
  readonly animSpeed: number;
}

/** Where the sword sits while the body plays a given cel. */
export interface KnightSwordFrame {
  /** Sword rotation, in degrees. */
  readonly aa: number;
  readonly xx: number;
  readonly yy: number;
}

/**
 * Body cels, indexed by `frame + animOffset`. The original allocated 80 rows,
 * but its sword table only ever had 78 values and no animation reaches past 77.
 */
export const KNIGHT_FRAMES: readonly KnightFrame[] = [
  /*  0 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  1 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  2 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  3 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  4 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  5 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  6 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  7 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  8 */ { xx: 0, yy: 0, animSpeed: 3 },
  /*  9 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 10 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 11 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 12 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 13 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 14 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 15 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 16 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 17 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 18 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 19 */ { xx: -5, yy: 0, animSpeed: 3 },
  /* 20 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 21 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 22 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 23 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 24 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 25 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 26 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 27 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 28 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 29 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 30 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 31 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 32 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 33 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 34 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 35 */ { xx: 0, yy: 0, animSpeed: 18 },
  /* 36 */ { xx: -3, yy: 4, animSpeed: 1 },
  /* 37 */ { xx: -3, yy: 4, animSpeed: 1 },
  /* 38 */ { xx: -3, yy: 4, animSpeed: 1 },
  /* 39 */ { xx: -3, yy: 4, animSpeed: 2 },
  /* 40 */ { xx: -3, yy: 4, animSpeed: 3 },
  /* 41 */ { xx: -3, yy: 4, animSpeed: 18 },
  /* 42 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 43 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 44 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 45 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 46 */ { xx: 0, yy: 0, animSpeed: 3 },
  /* 47 */ { xx: 0, yy: 0, animSpeed: 18 },
  /* 48 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 49 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 50 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 51 */ { xx: 0, yy: 0, animSpeed: 5 },
  /* 52 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 53 */ { xx: 0, yy: 0, animSpeed: 2 },
  /* 54 */ { xx: 0, yy: 0, animSpeed: 18 },
  /* 55 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 56 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 57 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 58 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 59 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 60 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 61 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 62 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 63 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 64 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 65 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 66 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 67 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 68 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 69 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 70 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 71 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 72 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 73 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 74 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 75 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 76 */ { xx: 0, yy: 0, animSpeed: 1 },
  /* 77 */ { xx: 0, yy: 0, animSpeed: 1 },
];

/** Sword placement per body cel, same indexing as `KNIGHT_FRAMES`. */
export const KNIGHT_SWORD_FRAMES: readonly KnightSwordFrame[] = [
  /*  0 */ { aa: 135, xx: -12, yy: -2 },
  /*  1 */ { aa: 134, xx: -12, yy: -2.5 },
  /*  2 */ { aa: 133, xx: -12, yy: -3 },
  /*  3 */ { aa: 132, xx: -12, yy: -4.4 },
  /*  4 */ { aa: 133, xx: -12, yy: -5.7 },
  /*  5 */ { aa: 134, xx: -12, yy: -6.4 },
  /*  6 */ { aa: 135, xx: -12, yy: -6.7 },
  /*  7 */ { aa: 136, xx: -12, yy: -6 },
  /*  8 */ { aa: 137, xx: -12, yy: -5 },
  /*  9 */ { aa: 136, xx: -12, yy: -3 },
  /* 10 */ { aa: 160, xx: -8, yy: -2 },
  /* 11 */ { aa: 159, xx: -8, yy: -2.5 },
  /* 12 */ { aa: 158, xx: -8, yy: -3 },
  /* 13 */ { aa: 157, xx: -8, yy: -4.4 },
  /* 14 */ { aa: 158, xx: -8, yy: -5.7 },
  /* 15 */ { aa: 159, xx: -8, yy: -6.4 },
  /* 16 */ { aa: 160, xx: -8, yy: -6.7 },
  /* 17 */ { aa: 161, xx: -8, yy: -6 },
  /* 18 */ { aa: 162, xx: -8, yy: -5 },
  /* 19 */ { aa: 161, xx: -8, yy: -3 },
  /* 20 */ { aa: 34, xx: 12, yy: -2 },
  /* 21 */ { aa: 35, xx: 12, yy: -2.5 },
  /* 22 */ { aa: 36, xx: 12, yy: -3 },
  /* 23 */ { aa: 37, xx: 12, yy: -4.4 },
  /* 24 */ { aa: 36, xx: 12, yy: -5.7 },
  /* 25 */ { aa: 35, xx: 12, yy: -6.4 },
  /* 26 */ { aa: 34, xx: 12, yy: -6.7 },
  /* 27 */ { aa: 33, xx: 12, yy: -6 },
  /* 28 */ { aa: 32, xx: 12, yy: -5 },
  /* 29 */ { aa: 33, xx: 12, yy: -3 },
  /* 30 */ { aa: 0, xx: 0, yy: 0 },
  /* 31 */ { aa: 0, xx: 0, yy: 0 },
  /* 32 */ { aa: 0, xx: 0, yy: 0 },
  /* 33 */ { aa: 0, xx: 0, yy: 0 },
  /* 34 */ { aa: 0, xx: 0, yy: 0 },
  /* 35 */ { aa: 0, xx: 0, yy: 0 },
  /* 36 */ { aa: 0, xx: 0, yy: 0 },
  /* 37 */ { aa: 0, xx: 0, yy: 0 },
  /* 38 */ { aa: 0, xx: 0, yy: 0 },
  /* 39 */ { aa: 0, xx: 0, yy: 0 },
  /* 40 */ { aa: 0, xx: 0, yy: 0 },
  /* 41 */ { aa: 0, xx: 0, yy: 0 },
  /* 42 */ { aa: 0, xx: 0, yy: 0 },
  /* 43 */ { aa: 0, xx: 0, yy: 0 },
  /* 44 */ { aa: 0, xx: 0, yy: 0 },
  /* 45 */ { aa: 0, xx: 0, yy: 0 },
  /* 46 */ { aa: 0, xx: 0, yy: 0 },
  /* 47 */ { aa: 0, xx: 0, yy: 0 },
  /* 48 */ { aa: -70, xx: -9, yy: -11 },
  /* 49 */ { aa: -45, xx: -9, yy: -11 },
  /* 50 */ { aa: -35, xx: -9, yy: -11 },
  /* 51 */ { aa: -10, xx: -10, yy: -11 },
  /* 52 */ { aa: -45, xx: -12, yy: -12 },
  /* 53 */ { aa: -90, xx: -14, yy: -10 },
  /* 54 */ { aa: -110, xx: -9, yy: -8 },
  /* 55 */ { aa: 0, xx: 0, yy: 0 },
  /* 56 */ { aa: 0, xx: 0, yy: 0 },
  /* 57 */ { aa: 0, xx: 0, yy: 0 },
  /* 58 */ { aa: 0, xx: 0, yy: 0 },
  /* 59 */ { aa: 0, xx: 0, yy: 0 },
  /* 60 */ { aa: 0, xx: 0, yy: 0 },
  /* 61 */ { aa: 0, xx: 0, yy: 0 },
  /* 62 */ { aa: 0, xx: 0, yy: 0 },
  /* 63 */ { aa: 0, xx: 0, yy: 0 },
  /* 64 */ { aa: 0, xx: 0, yy: 0 },
  /* 65 */ { aa: 0, xx: 0, yy: 0 },
  /* 66 */ { aa: 0, xx: 0, yy: 0 },
  /* 67 */ { aa: 0, xx: 0, yy: 0 },
  /* 68 */ { aa: 0, xx: 0, yy: 0 },
  /* 69 */ { aa: 0, xx: 0, yy: 0 },
  /* 70 */ { aa: 0, xx: 0, yy: 0 },
  /* 71 */ { aa: 0, xx: 0, yy: 0 },
  /* 72 */ { aa: 0, xx: 0, yy: 0 },
  /* 73 */ { aa: -195, xx: 1, yy: -7 },
  /* 74 */ { aa: 112, xx: -14, yy: -13 },
  /* 75 */ { aa: 60, xx: -22, yy: -7 },
  /* 76 */ { aa: 22, xx: -21, yy: 4 },
  /* 77 */ { aa: -15, xx: 0, yy: 7 },
];
